import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import styles from './styles.module.css';

const RotateScreen = ({ title, subtitle }) => {
  return (
    <>
      {/* tablet */}
      <div
        className={`${styles.rotateScreen} ${
          isMobile ? styles.mobileScreen : ''
        } ${styles.orientationTabletCopy}`}
      >
        <div className={styles.wrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="100 years"
              src="https://res.cloudinary.com/arts/image/upload/b_rgb:000000,c_scale,w_672/v1599635869/max-braun/intro/Braun_100yrs.jpg"
            />
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </div>
      {/* mobile */}
      <div
        className={`${styles.rotateScreen} ${
          isMobile ? styles.mobileScreen : ''
        } ${styles.orientationMobileCopy}`}
      >
        <div className={styles.wrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="100 years"
              src="https://res.cloudinary.com/arts/image/upload/b_rgb:000000,c_scale,w_672/v1599635869/max-braun/intro/Braun_100yrs.jpg"
            />
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </div>
    </>
  );
};

RotateScreen.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default RotateScreen;
